import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
import { TimeZoneService } from 'src/app/_services/time-zone.service';

@Pipe({
  name: 'timeZone'
})
export class TimeZonePipe implements PipeTransform {

  constructor(private timeZoneService: TimeZoneService) { }

  transform(inputValue: any, date: any, currLang: string, inputFormat: string, outPutFormat: string, translate: boolean = false, isdateTimeFormat: boolean = false, isConcatDateTime: boolean = false): string {
    if (!inputValue) return '';
    // Determine the output format based on the date-time flag and language
    const OutPutFormat = this.getOutputFormat(isdateTimeFormat, currLang, outPutFormat);
    // Detemine the input time based on the given value , given date and the concate date time flag 
    const inputTime = this.getTime(inputValue, date, isConcatDateTime);

    return this.timeZoneService.convertToLocalTime(
      inputTime,
      inputFormat,
      OutPutFormat,
      translate,
      currLang
    );
  }

  getOutputFormat(isDateTime: boolean, currLang: string, givenOutputFormat: string): string {
    // Determine the output format based on the date-time flag and language
    return isDateTime
      ? currLang === 'en'
        ? `DD/MM/YYYY ${String.fromCharCode(160)} hh:mm A`
        : `YYYY/MM/DD ${String.fromCharCode(160)} hh:mm A`
      : givenOutputFormat;
  }

  getTime(input: any, date: any, concatDateTime: boolean):string {
    // some passed values are in datetime format , but some values are just time only wich will make an issue with DST of old dates (so we need to concate the date from another key with the given time )
    if(concatDateTime && date){
      const formatedDate = moment(date).format('YYYY-MM-DD');
      return `${formatedDate} ${input}`
    }
    return input;
  }
}
